import { Tire } from "types/tire";

export const isCategorieInList = (tire: Tire, category: string[]) => {
  for (let i = 0; i < category.length; i++) {
    if (tire[category[i].replace(/\s/g, "") as keyof Tire]) {
      return true;
    } else if (category[i] === "Specials" && tire["RebateId" as keyof Tire]) {
      return true;
    } else {
      for (const tiretype of tire.TireTypes) {
        if (tiretype === category[i]) {
          return true;
        }
      }
    }
  }
  return false;
};
